export default __webpack_public_path__ + "static/media/SFProDisplay-Regular.1e1c0e29.ttf";